import { baseProductFilterSchema } from "@redotech/redo-model/product-filters/product-filters-db-parser";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getProductFilterById = {
  name: "getProductFilterById" as const,
  input: z.object({ id: z.string() }),
  output: z
    .intersection(z.object({ _id: zExt.objectId() }), baseProductFilterSchema)
    .optional(),
};
